module.exports = __webpack_public_path__ + "static/media/02.d67fc405.webp";